import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../../services/auth';
import { Router } from '@angular/router';
import { AlertService } from '../../services/alert.service';

@Injectable({ providedIn: 'root' })
export class AuthorizationInterceptor implements HttpInterceptor {
    private auth         = inject(AuthService);
    private router       = inject(Router);
    private alertService = inject(AlertService);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isLoggedIn = Boolean(this.auth.tokenValue);

        if (isLoggedIn) {
            req = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.auth.tokenValue}`,
                    Accept: 'application/json'
                }
            });
        }

        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                switch (error.status) {
                    case 401:
                        // Token expirado o inválido — limpiar sesión y redirigir
                        this.auth.clearSession();
                        this.router.navigate(['/login']);
                        break;
                    case 403:
                        // Límite alcanzado o sin permisos — mostrar modal de plan
                        if (error.error && error.error.message) {
                            this.alertService.showPlanLimit({
                                title: error.error.title ?? 'Se excedió tu plan',
                                message: error.error.message,
                            });
                        } else {
                            this.router.navigate(['/']);
                        }
                        break;
                }
                return throwError(() => error);
            })
        );
    }
}
